<template>
  <div class="container" style="height: auto;">
      <div class="section section1">
          <div class="section-inner section-inner1" @click="go">
              <div class="logo"></div>
              <div class="text"></div>
              <div class="qrcode_wrap">
                  <div class="qrcode"></div>
                  <div class="qrcode-text">扫描二维码了解更多</div>
              </div>
          </div>
      </div>
      <div class="section section2">
          <div class="section-inner section-inner2" @click="go">
              <div class="title-container">
                  <div class="title">拼购全球</div>
                  <div class="desc">品质海淘 全场保真</div>
              </div>
          </div>
      </div>
      <div class="section section3">
          <div class="section-inner section-inner3" @click="go">
              <div class="title-container">
                  <div class="title">潮流服饰</div>
                  <div class="desc">每季新款 潮流我先行</div>
              </div>
          </div>
      </div>
      <div class="section section4">
          <div class="section-inner section-inner4" @click="go">
              <div class="title-container">
                  <div class="title">数码3C</div>
                  <div class="desc">家用电器 假一赔十</div>
              </div>
          </div>
      </div>
      <div class="section section5">
        <div class="section-inner section-inner5" @click="go">
            <div class="title-container">
                <div class="title">医疗器械</div>
                <div class="desc">官方认证 安心保障</div>
            </div>
      </div>
      </div>
      <div class="foot" :class="{miniWrap: platform}">
        <div class="left">      
            <ul class="banner">
                <li @click="setTab(1)">首页</li>
                <li @click="setTab(2)">经销商</li>
                <li @click="setTab(4)">饷店功能服务</li>
                <li @click="setTab(5)">关于我们</li>
            </ul>
            <div class="address">联系地址：浙江省宁波市海曙区聚才路99号商务楼A幢603-2室</div>
            <div class="company">©宁波商量信息技术有限公司&nbsp;&nbsp;&nbsp;<a href="http://www.beian.miit.gov.cn">{{copy}}</a>&nbsp;&nbsp;&nbsp;经营许可证编号：合字B2-20200148</div>
        </div>
        <div class="right">
            <img :src="logo" alt="logo">
        </div>
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import logo from 'common/img/logo.png'

const host = window.location.host;
const isInStore = host.includes('xiangdian.store');
const isAkMaxx = host.includes('ak-maxx');
const isXiangtuanmallCom = host.includes('xiangtuanmall.com');
const isXiangtuanmallCn = host.includes('xiangtuanmall.cn');
const isAifadanXyz = host.includes('aifadan.xyz');
let copy = '';
if (isInStore) {
  // xiangdian.store
  copy = '浙ICP备19007772号-6';
} else if (isAkMaxx) {
  // ak-maxx.cn、ak-maxx.com、ak-maxx.com.cn
  copy = '浙ICP备19007772号-2';
} else if (isXiangtuanmallCom) {
  // xiangtuanmall.com
  copy = '浙ICP备19007772号-3';
} else if (isXiangtuanmallCn) {
  // xiangtuanmall.cn
  copy = '浙ICP备19007772号-4';
} else if (isAifadanXyz) {
  // aifadan.xyz
  copy = '浙ICP备19007772号-8';
} else {
  // xiangdian.shop
  copy = '浙ICP备19007772号-5';
}

export default {
    data() {
        return {
            logo,
            copy
        };
    },
    computed: {
        ...mapState([
        'platform'
        ])
    },
    methods: {    
        setTab(index) {
            const pathArr = ['', 'city', 'activity', 'shop', 'about']
            const path = `/${pathArr[index - 1]}`;
            const host = process.env.VUE_APP_SITE_DOMAIN;
            window.location.href = `${host}${path}`;
        },
        go() {
            location.href = '/mall/index.html';
        }
    }
}
</script>

<style lang="less" scoped>
.container {
    background-color: transparent;
    
    .section {
        width: 100%;
    }
    .section1 {
        background-color: #c51234;
    }
    .section2 {
        background-color: #FFF7F9;
    }
    .section3 {
        background-color: #F8FFF7;
    }
    .section4 {
        background-color: #FFFBF7;
    }
    .section-inner {
        margin: 0 auto;
        max-width: 1920px;
        min-width: 1200px;
    }
    .section-inner1 {
        height: 580px;
        position: relative;
        background: url('../common/img/part1@1x-2.png') no-repeat;
        background-size: cover;
        background-position: center;
        .logo {
            background: url('../common/img/xiangdian_logo.png') no-repeat;
            position: absolute;
            left: 36px;
            top: 24px;
            width: 124px;
            height: 40px;
            background-size: 124px 40px;
        }
        .text {
            background: url('../common/img/part1_slogan.png') no-repeat;
            position: absolute;
            left: 51.8%;
            top:185px;
            width: 356px;
            height: 98px;
            background-size: 356px 98px;
        }
        .qrcode_wrap {
            position: absolute;
            left: 57.7%;
            top: 318px;
            display: flex;
            align-items: center;
            flex-direction: column;
            .qrcode {
                width: 119px;
                height: 119px;
                flex-shrink: 0;
                background: url('../common/img/shop_qrcode.png') no-repeat;
                background-size: 119px 119px;
            }
            .qrcode-text {
                margin-top: 8px;
                font-size: 12px;
                line-height: 17px;
                letter-spacing: 1px;
                text-align: center;
                flex-shrink: 0;
                color: #fff;
            }
        }
    }
    .section {
        .section-inner {
            cursor: pointer;
            height: 600px;
            position: relative;
            background-size: cover;
            background-position: center;
        }
        .title-container {
            position: absolute;
            left: 44.43%;
            top: 88px;
            display: flex;
            align-items: center;
            flex-direction: column;
            .title {
                flex-shrink: 0;
                font-size: 40px;
                line-height: 56px;
                font-family:PingFang-SC-Heavy,PingFang-SC;
                font-weight:800;
                color: #333;
            }
            .desc {
                margin-top: 7px;
                font-size: 24px;
                line-height: 33px;
                color: #666;
                font-family:PingFangSC-Regular,PingFang SC;
            }
        }
    }
    .section-inner2 {
        background: url('../common/img/part2@1x-min.png') no-repeat;
        
    }
    .section-inner3 {
        background: url('../common/img/part3@1x-min.png') no-repeat;
    }
    .section-inner4 {
        background: url('../common/img/part4@1x-min.png') no-repeat;
    }
    .section5 {
        background-color: rgba(247,252,255,1);
        .title-container{
            top: 70px;
        }
        .section-inner5 {
            cursor: pointer;
            background: url('../common/img/part5.png') no-repeat;
            background-color: rgba(247,252,255,1);
            background-size: 557px 364px;
            background-position: center 80px;
            height: 450px;
            position: relative;
        }
    }
    .foot {
        width: 1000px;
        min-width: 1000px;
        height: 107px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        background: #fff;
        position: relative;
        margin: 0 auto;
        .left {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            font-family: PingFangSC-Regular, sans-serif;
            .banner {
                font-size: 14px;
                color: #666;
                margin-top: 16px;
                li {
                    display: inline-block;
                    padding: 0 20px;
                    line-height: 20px;
                    position: relative;
                    cursor: pointer;
                    &:hover {
                        color: #EC2232;
                    }
                    &::after {
                        content: '|';
                        position: absolute;
                        right: 0;
                        top: 1px;
                        height: 16px;
                        overflow: hidden;
                    }
                    &:last-child::after {
                        content: '';
                    }
                    &:first-child {
                        padding-left: 0;
                    }
                }
            }
            .address, .company {
                color: #999;
                font-size: 12px;
                line-height: 17px;
                a {
                    color: #999;
                    text-decoration: underline;
                    &:active, &:hover {
                        color: #999
                    }
                }
            }
            .address {
                margin-top: 13px;
            }
            .company {
                margin-top: 6px;
            }
        }
        .right {
            img {
                margin-top: 23px;
                width: 127px;
                height: 60px;
            }
        }
    }
}
</style>